import { GridColumnType } from "../../../../components/FinalMolGrid/libs/data/gridColumnType";

/** Table Column Configration */
export const TimesheetListGridConfig = {
  columns: [
    {
      name: "Project",
      fieldName: "projectName",
      allowShort: false,
    },
    {
      name: "Task",
      fieldName: "title",
      allowShort: false,
    },

    {
      name: "User",
      fieldName: "userName",
      allowShort: false,
    },
    {
      name: "Task Activity",
      fieldName: "activityName",
      allowShort: false,
    },
    {
      name: "Task Type",
      fieldName: "taskTypeName",
      allowShort: false,
    },
    {
      name: "Work Description",
      fieldName: "workDescription",
      allowShort: false
  },
    {
      name: "Work At",
      fieldName: "workAt",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD/MM/YYYY",
      },
allowShort: false
  },
    {
      name: "Start Time",
      fieldName: "startTime",
      // colType: GridColumnType.TIME,
      // colSettings: {
      //   format: "HH:mm",
      // },
      allowShort: false,
    },
    {
      name: "End Time",
      fieldName: "endTime",
      colType: GridColumnType.TIME,
      colSettings: {
        format: "HH:mm",
      },
      allowShort: false,
    },
    {
      name: "Duration",
      fieldName: "workingHours",
      allowShort: false,
    },
  ],
};